import _ from 'lodash';
import { USER_ROLES } from './constants';
import ReportNames from './reportNames';

const Reports = [
  {
    name: ReportNames.HotWorkManager,
    report_code: '15',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
    },
  },
  {
    name: ReportNames.AllFixedWorkDetailedStatementPayment,
    report_code: '22',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      time_zone_display_flag: 0,
      partner_company_1_unit_display_flag: 0,
    },
  },
  {
    name: ReportNames.AllUnfixedWorkDetailedStatementPayment,
    report_code: '23',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      time_zone_display_flag: 0,
      partner_company_1_unit_display_flag: 0,
    },
  },
  {
    name: ReportNames.AllWorkDetailedStatementPayment,
    report_code: '24',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      time_zone_display_flag: 0,
      partner_company_1_unit_display_flag: 0,
    },
  },
  {
    name: ReportNames.AllNishimatsuKy,
    report_code: '31',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      specifying_period_display_flag: 0,
    },
  },
  {
    name: ReportNames.CstmObayashiAllAdjustWork,
    report_code: '48',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      key_plan_display_flag: 0,
      specifying_period_display_flag: 0,
    },
  },
  {
    name: ReportNames.CstmObayashiAllResultWork,
    report_code: '49',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      key_plan_display_flag: 0,
      specifying_period_display_flag: 0,
    },
  },
  {
    name: ReportNames.KKosuseiri,
    report_code: '51',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      partner_company_1_unit_display_flag: 0,
      select_approval_display_flag: 1,
    },
  },
  {
    name: ReportNames.Ky,
    report_code: '77',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      partner_company_display_flag: 0,
    },
  },
  {
    name: ReportNames.Ky1,
    report_code: '90',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      partner_company_display_flag: 0,
    },
  },
  {
    name: ReportNames.ToutetsuKyJR,
    report_code: '95',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      partner_company_display_flag: 0,
    },
  },
  {
    name: ReportNames.ObayashiAllAdjustWork,
    report_code: '102',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      field_item_list1_display_flag: 0,
      field_item_list2_display_flag: 0,
      field_item_list3_display_flag: 0,
      field_item_list4_display_flag: 0,
      foreman_user_display_flag: 0,
      key_plan_display_flag: 0,
      specifying_period_display_flag: 0,
    },
  },
  {
    name: ReportNames.ObayashiAllResultWork,
    report_code: '103',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      field_item_list1_display_flag: 0,
      field_item_list2_display_flag: 0,
      field_item_list3_display_flag: 0,
      field_item_list4_display_flag: 0,
      foreman_user_display_flag: 0,
      key_plan_display_flag: 0,
      specifying_period_display_flag: 0,
    },
  },
  {
    name: ReportNames.HpsKyL,
    report_code: '117',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      partner_company_display_flag: 0,
    },
  },
  {
    name: ReportNames.HpsKyS,
    report_code: '118',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      partner_company_display_flag: 0,
    },
  },
  {
    name: ReportNames.NakayamaKy,
    report_code: '99',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      partner_company_display_flag: 0,
    },
  },
  {
    name: ReportNames.TouyouKy,
    report_code: '126',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      partner_company_display_flag: 0,
    },
  },
  {
    name: ReportNames.NakanofudouKy,
    report_code: '128',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      partner_company_display_flag: 0,
    },
  },
  {
    name: ReportNames.Cr579KonoikeB,
    report_code: '132',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      partner_company_display_flag: 0,
    },
  },
  {
    name: ReportNames.AllKYWork,
    report_code: '4',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      key_plan_display_flag: 0,
      specifying_period_display_flag: 0,
    },
  },
  {
    name: ReportNames.AllAdjustWork,
    report_code: '5',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      key_plan_display_flag: 0,
      specifying_period_display_flag: 0,
    },
  },
  {
    name: ReportNames.AllResultWork,
    report_code: '6',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      key_plan_display_flag: 0,
      specifying_period_display_flag: 0,
    },
  },
  {
    name: ReportNames.AllKY,
    report_code: '7',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      key_plan_display_flag: 0,
    },
  },
  {
    name: ReportNames.Cr690TekkenKy,
    report_code: '145',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      specifying_period_display_flag: 0,
    },
  },
  {
    name: ReportNames.Cr692UkgAllWork,
    report_code: '147',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      partner_company_display_flag: 0,
    },
  },
  {
    name: ReportNames.Cr630AndouhazamaKyPonchie,
    report_code: '152',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      partner_company_display_flag: 0,
      field_group_display_flag: 0,
    },
  },
  {
    name: ReportNames.Cr697DainihondobokuAllKyWork,
    report_code: '154',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      specifying_period_display_flag: 0,
    },
  },
  {
    name: ReportNames.Cr807KumagaiAllKycWork,
    report_code: '164',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
    },
  },
  {
    name: ReportNames.Cr809FudotetraAllKyWork,
    report_code: '166',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      specifying_period_display_flag: 0,
    },
  },
  {
    name: ReportNames.Cr813TokyuCnstKy,
    report_code: '170',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      specifying_period_display_flag: 0,
    },
  },
  {
    name: ReportNames.Cr814TaikiAllKyWork,
    report_code: '171',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      key_plan_display_flag: 0,
      specifying_period_display_flag: 0,
    },
  },
  {
    name: ReportNames.Cr819AndouhazamaKyMinisagyoTejyunsho,
    report_code: '176',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      partner_company_display_flag: 0,
      field_group_display_flag: 0,
    },
  },
  {
    name: ReportNames.Cr820AndouhazamaKyUramenNashi,
    report_code: '177',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      partner_company_display_flag: 0,
      field_group_display_flag: 0,
    },
  },
  {
    name: ReportNames.Cr825KyReportPs,
    report_code: '182',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      specifying_period_display_flag: 0,
    },
  },
  {
    name: ReportNames.Cr827KYTetsudo,
    report_code: '184',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      specifying_period_display_flag: 0,
    },
  },
  {
    name: ReportNames.Cr831MeikoAllKyWork,
    report_code: '188',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      specifying_period_display_flag: 0,
    },
  },
  {
    name: ReportNames.Cr835AllKyWork,
    report_code: '192',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      partner_company_display_flag: 0,
    },
  },
  {
    name: ReportNames.Cr837AllKyWork,
    report_code: '195',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      partner_company_display_flag: 0,
    },
  },
  {
    name: ReportNames.Cr838AndouhazamaAllCraneUse,
    report_code: '196',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      partner_company_1_display_flag: 0,
    },
  },
  {
    name: ReportNames.Cr839AndouhazamaMachineryInstruction,
    report_code: '197',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      partner_company_1_display_flag: 0,
    },
  },
  {
    name: ReportNames.Cr842WorkAndDiary,
    report_code: '200',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      partner_company_1_display_flag: 0,
    },
  },
  {
    name: ReportNames.Cr843AllKyWork,
    report_code: '201',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      partner_company_1_display_flag: 0,
    },
  },
  {
    name: ReportNames.Cr845JFEAllResult,
    report_code: '203',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      partner_company_display_flag: 0,
      key_plan_display_flag: 0,
      specifying_period_display_flag: 0,
    },
  },
  {
    name: ReportNames.Cr847OrscRaky,
    report_code: '205',
    roles: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
    displayFlags: {
      foreman_user_display_flag: 0,
      partner_company_display_flag: 0,
      field_group_display_flag: 0,
    },
  },
];

/**
 * 帳票一覧画面上の帳票の各絞り込み条件の値を、ロールにより取得する
 *
 * @param {String} reportCode 帳票番号
 * @param {number} role ログイン中のロール
 * @return 帳票絞り込み条件の値のあるオブジェクト
 */
const getDisplayFlagsByConditions = (reportCode, role) => {
  const report = _.find(Reports, r => {
    if (r.report_code !== reportCode) {
      return false;
    }
    if (r.hasOwnProperty('roles') && !r.roles.includes(parseInt(role))) {
      return false;
    }
    return true;
  });
  return report ? report.displayFlags : null;
};

const ReportDisplayOptions = { getDisplayFlagsByConditions };
export default ReportDisplayOptions;



// WEBPACK FOOTER //
// ./src/utilities/reportDisplayOptions.js